<div class="list-group-item-spacing" (click)="selectElement()">
  <div
    #listItem
    [class.active]="isActive"
    [class.d-none]="hideDisabled && disabled"
    [class.disabled]="deactivated || disabled"
    [class.highlighted]="highlighted"
    [class.checkboxes]="displayCheckbox"
    class="btn list-group-item list-group-item-action d-flex flex-row"
    [attr.tabIndex]="itemTabIndex"
  >
    <div
      *ngIf="displayCheckbox; else elseBlock"
      class="form-check"
    >
      <input
        [checked]="isActive"
        [disabled]="deactivated || disabled"
        class="form-check-input"
        type="checkbox"
      />
      <label class="ds-cursor--pointer form-check-label">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
      </label>
    </div>
    <ng-template #elseBlock>
      <div class="d-flex w-100">
        <span [ngClass]="{
                    'd-flex': !isRowContent,
                    'd-block': isRowContent
                    }"
          class="list-group-item-content">
          <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
        </span>
        <span *ngIf='isEditable' class="edit-btn-wrapper ps-4"
              (click)="$event.stopPropagation(); onEditClick(isEditDisabled)"
              [class.disabled]="isEditDisabled"
              [class.default-cursor]="isEditDisabled">
          <span container="body"
                [ngbTooltip]="editButtonTooltip"
                [placement]="editButtonTooltipPlacement">
            <button type="button"
                    class="btn btn-link d-flex ps-0 pe-0"
                    [disabled]="isEditDisabled">
                <em class="ds-icon ds-icon--edit mt-1 me-2"></em>
                <span class="edit-btn-text">{{ editButtonText }}</span>
            </button>
          </span>
        </span>
      </div>
    </ng-template>
    <ng-template #contentTpl>
      <ng-content></ng-content>
    </ng-template>
  </div>
</div>
